import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/hero/hero_2_title_1.png")